import { createSlice } from '@reduxjs/toolkit';
import {
  getMonitorDependencies,
  saveMonitorSettings,
} from 'features/admin-monitoring/dependencies/async';
import { MonitoringDependenciesState } from 'features/admin-monitoring/dependencies/types';
import {
  fulfilled,
  initialRequestState,
  pending,
  rejected,
  requestReducer,
} from 'features/shared/request';

export const initialState: MonitoringDependenciesState = {
  graph: { data: undefined, request: initialRequestState },
};

const slice = createSlice({
  name: 'monitoringDependencies',
  initialState,
  reducers: {
    reset: (state) => {
      state.monitorKey = undefined;
      state.graph = { data: undefined, request: initialRequestState };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMonitorDependencies.pending, (state, { meta }) => {
      state.monitorKey = meta.arg.monitorKey;
      state.graph.data = undefined;
      state.graph.request = requestReducer(
        state.graph.request,
        pending({ meta })
      );
    });
    builder.addCase(
      getMonitorDependencies.fulfilled,
      (state, { meta, payload }) => {
        if (state.graph.request.id === meta.requestId) {
          state.graph.data = payload;
          state.graph.request = requestReducer(
            state.graph.request,
            fulfilled({ meta })
          );
        }
      }
    );
    builder.addCase(getMonitorDependencies.rejected, (state, { meta }) => {
      state.graph.request = requestReducer(
        state.graph.request,
        rejected({ meta })
      );
    });

    builder.addCase(
      saveMonitorSettings.fulfilled,
      (state, { meta, payload }) => {
        if (state.monitorKey === meta.arg.monitorKey && payload.dependencies) {
          state.graph.data = payload.dependencies;
        }
      }
    );
  },
});

export const { reset } = slice.actions;

const { reducer } = slice;

export default reducer;
